// Support resources catalog — Manager view (PROJECT.md Manager-portal gap
// #5). Reframed for the manager reading it on someone else's behalf:
// third-person signposting copy, not the Employee view's second-person
// personal reassurance — no `CalmFooter`-style closing note, since that
// register doesn't fit an operational manager tool.
//
// Card grid + query itself lives in `components/ResourceCatalogGrid.tsx`,
// shared with `EmployeeResourcesCard.tsx` — this owns only the Manager-
// specific header copy and the "when to suggest it" framing.

import { ResourceCatalogGrid } from '@/components/ResourceCatalogGrid.tsx';

export function ManagerResources() {
  return (
    <section className="space-y-6">
      <header>
        <h1 className="text-2xl font-semibold tracking-tight">Support resources</h1>
        <p className="mt-2 text-muted-foreground">
          External and internal support you can point your team toward — nothing here is tracked or
          reported.
        </p>
      </header>

      <ResourceCatalogGrid
        endpoint="/api/manager/resources"
        queryKey={['manager', 'resources']}
        whenToUseLabel="When to suggest it:"
      />
    </section>
  );
}
